module.exports = function (first, last, value, options) {
  var answer = getAnswer(first + '-' + last);
  if (answer === value) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
};
